module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Regular-exported.0798226f.ttf";